import React,{useEffect} from 'react'
import BannerComponent from '../Common-Component/BannerComponent/BannerComponent'
import WelcomeComponent from './WelcomeComponent/WelcomeComponent'
import './AboutUs.css'
import WhatWeAre from './WhatWeAre/WhatWeAre'
import WhatDoesPrintoutDo from './WhatDoesPrintoutDo/WhatDoesPrintoutDo'
import TalkToUs from './TalkToUs/TalkToUs'




const AboutUs = () => {

    

    const welcomeText = "Welcome to PRINTOUT Media! We make printing and gifting effortless."
    const para1 = "As India’s largest print-on-demand platform, we aim to become the world's leading provider. With over 15 years of expertise in the print industry, we operate 28 retail stores across six cities & have proudly served more than 1 million online and offline customers. Businesses of all sizes, creators, and individuals trust SM Pront Out Media for top-quality print services, with seamless shipping across India & globally."
    const para2 = "Our team of 1,000+ employees across six cities ensures excellence in every print. We are also home to India’s largest wedding album design and production company—Canvera.com. A trusted name in the event photography industry, Canvera has over 1 lakh photographers using the platform to create stunning wedding albums."

    return (
        <section className='AboutUs'>
            <BannerComponent img="\assets\Images\AboutUs\banner.png" title="About Us" />

            <div className='container'>
                <div className='below_banner_section'>
                    <WelcomeComponent title_text={welcomeText} para1={para1} para2={para2}/>

                    <div className='below_welcome_data'>
                        <WhatWeAre />
                        <WhatDoesPrintoutDo/>
                        <TalkToUs/>
                    </div>

                </div>
            </div>

        </section>
    )
}

export default AboutUs
